import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'

import { TrainingProgramOverlay } from '#app/routes/mocra+/_form+/components/training-programs/overlay.tsx'
import {
	createTrainingProgramDraft,
	type TrainingProgramDraft,
} from '#app/routes/mocra+/_form+/components/training-programs/types.ts'

type Props = {
	readonly onSubmit: (draft: TrainingProgramDraft) => void
	readonly defaultValue?: TrainingProgramDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function TrainingProgramAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: TrainingProgramDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add training program'}
			</AddButton>
			<TrainingProgramOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createTrainingProgramDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
